import { render } from "./EditNft.vue?vue&type=template&id=2b812f9a&scoped=true"
import script from "./EditNft.vue?vue&type=script&lang=js"
export * from "./EditNft.vue?vue&type=script&lang=js"

import "./EditNft.vue?vue&type=style&index=0&id=2b812f9a&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b812f9a"]])

export default __exports__